module.exports = __webpack_public_path__ + "assets/img/CreditCard2.3ba766eb.png";